export const get = state => state.user;
export const getPartnerId = state => state.user["https://salespartner.rikstv.no/partnerid"] || '';